import React, { FC } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Link from '../LocalizedLink';

import Logo from '../Logo';
import SocialList from '../SocialList';
import Navigation from '../Navigation';
import PaymentProcessors from '../PaymentProcessors';
import { PAYMENTS_ENABLED } from '../../helpers/paymentAvailability';

import { Email, Divider, BottomLine, Phone, Box, Wrapper } from './styles';

const Footer: FC = () => {
  const { t } = useTranslation(['common']);
  return (
    <Wrapper>
      <Box>
        <Email href="mailto:forestshopcarpatian@gmail.com">forestshopcarpatian@gmail.com</Email>
        <SocialList />
      </Box>

      <Divider />
      <Box>
        <Logo />
        <Navigation />
      </Box>
      <BottomLine>
        <p>
          © Amanita Store 2019-{new Date().getFullYear()} <Link to="/policy">{t('FOOTER.policy')}</Link>
        </p>
        {PAYMENTS_ENABLED && <PaymentProcessors text={t('FOOTER.securePayment')} />}
      </BottomLine>
    </Wrapper>
  );
};

export default Footer;
